import { useEffect, useId, useRef, useState } from 'react';
import { Camera, CameraOff, ScanLine } from 'lucide-react';
import { Html5Qrcode } from 'html5-qrcode';
import { normalizeMgmCode } from './lib/mgm.js';

export function MgmReferralInput({ value, onChange, label = 'Kode referral member', hint }) {
  const elementId = `mgm-scanner-${useId().replace(/:/g, '')}`;
  const scannerRef = useRef(null);
  const [scanning, setScanning] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => () => {
    scannerRef.current?.stop?.().catch(() => {});
    scannerRef.current?.clear?.().catch(() => {});
  }, []);

  async function stopScanner() {
    const scanner = scannerRef.current;
    scannerRef.current = null;
    if (scanner) {
      await scanner.stop().catch(() => {});
      await scanner.clear().catch(() => {});
    }
    setScanning(false);
  }

  async function startScanner() {
    setError('');
    try {
      const scanner = new Html5Qrcode(elementId);
      scannerRef.current = scanner;
      setScanning(true);
      await scanner.start(
        { facingMode: 'environment' },
        { fps: 10, qrbox: { width: 220, height: 220 } },
        async (decodedText) => {
          onChange(normalizeMgmCode(decodedText));
          await stopScanner();
        },
        () => {},
      );
    } catch (scanError) {
      scannerRef.current = null;
      setScanning(false);
      setError(scanError?.message || 'Kamera tidak dapat dibuka. Kode tetap dapat diketik manual.');
    }
  }

  return (
    <div className="form-field">
      <label>{label}</label>
      <div className="mgm-code-row">
        <input
          value={value}
          onChange={(event) => onChange(normalizeMgmCode(event.target.value))}
          placeholder="MGM-XV-AB12CD34"
          maxLength={80}
          autoComplete="off"
        />
        <button type="button" className="button button-quiet" onClick={scanning ? stopScanner : startScanner}>
          {scanning ? <CameraOff size={17} /> : <Camera size={17} />}
          {scanning ? 'Tutup' : 'Scan'}
        </button>
      </div>
      {hint ? <small>{hint}</small> : null}
      {error ? <small style={{ color: '#b91c1c' }}>{error}</small> : null}
      <div id={elementId} className={scanning ? 'mgm-scanner' : ''} aria-label="Pemindai QR referral" />
      {scanning ? <span className="mgm-scanner-hint"><ScanLine size={15} /> Arahkan kamera ke QR member</span> : null}
    </div>
  );
}
